
import { InvItem, Recipes } from "@/models/GameType";
import { toArray } from "lodash";
import { Component, Prop, Vue } from "vue-property-decorator";

@Component
class RecipeBoxAdd extends Vue {
  @Prop({ default: null }) readonly invData!: InvItem[];
  @Prop({ default: null }) readonly recipe!: Recipes;
  @Prop({ default: null }) readonly currentInv!: string;
  itemName = {} as any;
  quantity = 1;
  invItemArray: InvItem[] = [];

  get getOptions(): any[] {
    const arr: any = [];
    this.invItemArray.forEach((x: InvItem) => {
      if (
        (this.recipe === null || this.recipe.items[x.slug] === undefined) &&
        x.slug !== this.currentInv
      ) {
        arr.push({ value: x.slug, text: x.name.en });
      }
    });
    return arr;
  }

  cancel(): void {
    this.$emit("cancel");
  }

  created(): void {
    this.invItemArray = toArray(this.invData);
    this.itemName = this.invItemArray[0].slug;
  }

  save(): void {
    var values = {
      item: this.getOptions.find((x) => x.value === this.itemName).text,
      quantity: this.quantity,
      slug: this.itemName,
    };
    this.$emit("receipeData", values);
  }
}
export default RecipeBoxAdd;
